__webpack_require__.p = "https://eg-admin.learnstage.com/";